module.exports = __webpack_public_path__ + "static/img/2.c1cac28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/clix/2.png
// module id = ni2t
// module chunks = 35